import { ReactNode } from 'react';
import { useThreadHeaderContext } from '@frontend/thread-header-context';
import { PersonSecondaryInfo, PersonSecondaryInfoProps } from '../person-secondary-info';

type InfoProps = Omit<PersonSecondaryInfoProps, 'personId' | 'groupId' | 'person' | 'groupIds'>;

export const Info = (props: InfoProps & { isCompactMode?: boolean; additionalInfo?: string | ReactNode }) => {
  const { groupId, primaryContact, primaryContactId, contextContact, contextPersonId, isLead } =
    useThreadHeaderContext();
  const hasChildren = Array.isArray(props.children) ? props.children.length > 0 : !!props.children;
  const personId = contextPersonId || contextContact?.personId || primaryContactId || primaryContact?.personId;
  const person = contextContact ?? primaryContact;
  const isLeadContact = isLead || (!personId && !!(person?.firstName || person?.lastName));

  if (!hasChildren && !isLeadContact && (!personId || !groupId)) return null;

  return (
    <PersonSecondaryInfo
      {...props}
      isLead={isLead}
      personId={personId ?? ''}
      groupIds={groupId ? [groupId] : undefined}
      person={person}
    />
  );
};
